export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Création de widget pour"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Annuler"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Compte"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Générer"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paiement en"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant du paiement"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions en cas de succès"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actions en cas d'échec"])}
}